module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BasePage', {
    attrs: {
      "title": "Forgot Password"
    }
  }, [_c('section', {
    staticClass: "d-flex justify-content-center align-items-center"
  }, [_c('div', [_c('h1', {
    staticClass: "fs-10"
  }, [_vm._v("Authenticating with Social Account...")]), _vm._v(" "), _vm._t("default", [_c('p', {
    staticClass: "fs-8 text-muted"
  }, [_vm._v("this may take a few moments ")])])], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-dd2da4ce"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OAuthLoginCallback.vue
// module id = 1089
// module chunks = 0